<template>
  <div style="padding: 10px">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :key="0" :label="$t('tablePrice.networkDimension')" name="first">
        <siteIndex v-if="isShow" />
      </el-tab-pane>
      <el-tab-pane :key="1" :label="$t('tablePrice.regionDimension')" name="second">
        <regionIndex v-if="isShow1" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'BagWork',
  components: {
    siteIndex: () => import('./component/siteIndex.vue'),
    regionIndex: () => import('./component/regionIndex.vue')
  },
  data() {
    return {
      activeName: 'first',
      isShow: true,
      isShow1: false
    };
  },
  methods: {
    handleClick(tab, event) {
      if (tab.name === 'first') {
        this.isShow1 = false;
        this.isShow = true;
      }
      if (tab.name === 'second') {
        this.isShow = false;
        this.isShow1 = true;
      }
    }
  }
};
</script>

<style scoped></style>
